import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Заявка отправлена!',
  subTitle: 'Ожидайте обратную связь по заявке в течение рабочего дня',
  buttons: {
    close: 'Закрыть',
    goToRequest: 'К заявке',
  },
} as const satisfies TMessages
